var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')

module.exports = {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true,
    },
    stage: String,
    verifyWay: String,
    verifyType: String,
    verifyInfo: String,
  },

  data: function () {
    return {
      modalWidth: 600,
      code: "",
      password: "",
      errorInfo: "",
    }
  },

  computed: {
    modalTitle: function() {
      if(this.stage=='code') {
        return "输入验证码"
      } else if(this.stage=='reset') {
        return '重置密码'
      } else if(this.stage=='finish') {
        return '操作成功'
      }
    },

    codeInfo: function() {
      if(this.verifyWay=='phone') {
        return "验证码已经发送到: "+ this.verifyInfo + "，请输入验证码完成操作"
      } else if(this.verifyWay=="email") {
        return "验证码已经发送到: "+ this.verifyInfo + "，请输入验证码或点击邮件中的验证链接完成操作"
      }
    },

    finishInfo: function() {
      if(this.verifyType=='bind') {
        return "信息绑定成功！"
      } else if(this.verifyType=='reset') {
        return "密码重置成功！请牢记您的新密码"
      }
    },
  },

  methods: {
    onConfirm: function() {
      var vuemodel = this
      if(this.stage=="code") {
        if(this.verifyType=='bind') {
          bindUserInfo(this)
        } else if(this.verifyType=='reset') {
          verifyResetCode(this)
        }
      } else if(this.stage=='reset') {
        resetPassword(this)
      } else if(this.stage=='finish') {
        this.show = false
        vuemodel.errorInfo = ""
        window.location.reload()
      }
    },
  },

  components: {
    'modal': require('./modal.vue'),
  }
}

function bindUserInfo(vuemodel) {
  yy_request.rest_api({
    method: 'put',
    api: 'user/' + po.userinfo.id +'/' + vuemodel.verifyWay,
    data: {
      code: vuemodel.code,
    },
    opSuccess: function(info) {
      vuemodel.stage = 'finish'
      vuemodel.errorInfo = ""
    },
    opFail: function(info) {
      vuemodel.errorInfo = info
    },
  })
}

function verifyResetCode(vuemodel) {
  var api_url = 'password/code'
  var ajax_data = {
    code: vuemodel.code,
  }

  yy_request.rest_api({
    method: 'post',
    api: 'password/code',
    data: {
      code: vuemodel.code,
    },
    opSuccess: function(info) {
      vuemodel.stage = 'reset'
      vuemodel.errorInfo = ""
    },
    opFail: function(info) {
      vuemodel.errorInfo = info
    },
  })
}

function resetPassword(vuemodel) {
  var md5 = require("blueimp-md5")
  yy_request.rest_api({
    method: 'post',
    api: 'password/',
    data: {
      password: md5(vuemodel.password)
    },
    opSuccess: function(info) {
      vuemodel.stage = 'finish'
      vuemodel.errorInfo = ""
    },
    opFail: function(info) {
      vuemodel.errorInfo = info
    },
  })
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/verifycode-modal.vue
// module id = 147
// module chunks = 0